// extracted by mini-css-extract-plugin
module.exports = {"ProductFeatures":"ProductFeatures___10KaJ","dark":"dark___1izcW"};